export enum BarrierCategoryTypes{
    "Recruitment Procedures" = 1,
    "Advertising Positions" = 2,
    "Selection Criteria" = 3,
    "Appointments" = 4,
    "Job Classification and Grading" = 5,
    "Remuneration and benefits" = 6,
    "Terms & Conditions of Employment" = 7,
    "Work Environment and Facilities" = 8,
    "Training and Development" = 9,
    "Performance and Evaluation" = 10,
    "Succession & Experience Planning" = 11,
    "Disciplinary Measures" = 12, 
    "Retention of designated groups" = 13,
    "Corporate Culture" = 14,
    "Reasonable Accommodation" = 15,
    "HIV & AIDS Prevention and Wellness Programmes" = 16,
    "Assigned Senior Manager(s) to Manage EE Implementation" = 17,
    "Budget Allocation in Support of Employment Equity Goals" = 18,
    "Time off for employment equity consultative committee to meet" = 19,
    "Harassment" = 20,
    "Job Assignments" = 21,
    "Promotions" = 22,
    "Transfers" = 23,
    "Dismissals" = 24,
}
